module.exports = __webpack_public_path__ + "static/media/icon_config_switch_lighting-1.4266c74d.svg";